import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEraser"><Path fillRule="evenodd" clipRule="evenodd" d="M14.025 1.56104L22.3904 10.524L11.9144 21.0001H7.58594L1.08594 14.5001L14.025 1.56104ZM3.91436 14.5001L8.41437 19.0001H11.0859L12.3359 17.7501L6.50015 11.9143L3.91436 14.5001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEraser;
